<template>
	<jc-page :style="wrapperStyle">
		<!-- <uni-nav-bar leftIcon="" :title="componentData.name ? componentData.name : '主页'" :border="false" :fixed="true" statusBar :color="vuex_fontColor" :backgroundColor="vuex_backgroundColor"></uni-nav-bar> -->
		<uni-nav-bar leftIcon="" :title="'首页'" :border="false" :fixed="true" statusBar :color="vuex_fontColor" :backgroundColor="vuex_backgroundColor"></uni-nav-bar>
		<!-- #ifndef MP-WEIXIN -->
		<view v-for="(item,index) in componentData.decorateModuleInfoBoList" :key="index">
			<component v-if="item.moduleNo=='Z10'" :is="uSearch" :componentId="item.id" :data="item.decorateSearchBarBo"></component>
			<component v-if="item.moduleNo=='Z01'" :is="uSlideshow" :componentId="item.id" :data="item.decoratePicBo"></component>
			<component v-if="item.moduleNo=='Z12'" :is="uHeadline" :componentId="item.id" :data="item.decorateNoticeBo"></component>
			<component v-if="item.moduleNo=='Z02'" :is="uSimplegraph" :componentId="item.id" :data="item.decorateNavigationBo"></component>
			<component v-if="item.moduleNo=='P01'" :is="uGoodslist" :componentId="item.id" :data="item.decorateProdBo"></component>
			<component v-if="item.moduleNo=='Z03'" :is="uTitle" :componentId="item.id" :data="item.decorateTitleBo"></component>
			<component v-if="item.moduleNo=='Z05'" :is="uRichtext" :componentId="item.id" :data="item.decorateRichtextBo"></component>
			<component v-if="item.moduleNo=='Z06'" :is="uVideo" :componentId="item.id" :data="item.decorateVideoBo"></component>
			<component v-if="item.moduleNo=='F03'" :is="uShareButton" :componentId="item.id" :data="item.decorateShareBo"></component>
		</view>
		<!-- #endif -->
		<!-- #ifdef MP-WEIXIN -->
		<view v-for="(item,index) in componentData.decorateModuleInfoBoList" :key="index">
			<uSearch v-if="item.moduleNo=='Z10'" :is="uSearch" :componentId="item.id" :data="item.decorateSearchBarBo"></uSearch>
			<uSlideshow v-if="item.moduleNo=='Z01'" :is="uSlideshow" :componentId="item.id" :data="item.decoratePicBo"></uSlideshow>
			<uHeadline v-if="item.moduleNo=='Z12'" :is="uHeadline" :componentId="item.id" :data="item.decorateNoticeBo"></uHeadline>
			<uSimplegraph v-if="item.moduleNo=='Z02'" :is="uSimplegraph" :componentId="item.id" :data="item.decorateNavigationBo"></uSimplegraph>
			<uGoodslist v-if="item.moduleNo=='P01'" :is="uGoodslist" :componentId="item.id" :data="item.decorateProdBo"></uGoodslist>
			<uTitle v-if="item.moduleNo=='Z03'" :is="uTitle" :componentId="item.id" :data="item.decorateTitleBo"></uTitle>
			<uRichtext v-if="item.moduleNo=='Z05'" :is="uRichtext" :componentId="item.id" :data="item.decorateRichtextBo"></uRichtext>
			<uVideo v-if="item.moduleNo=='Z06'" :is="uVideo" :componentId="item.id" :data="item.decorateVideoBo"></uVideo>
			<uShareButton v-if="item.moduleNo=='F03'" :is="uShareButton" :componentId="item.id" :data="item.decorateShareBo"></uShareButton>
		</view>
		<!-- #endif -->
		<view class="cu-tabbar-height"></view>
	</jc-page>
</template>

<script setup>
	/**
	 * 组件引入
	 */
	import uSimplegraph from "@/decorates/u_simplegraph.vue"; // 图片导航组件
	import uGoodslist from "@/decorates/u_goodslist.vue"; // 商品列表组件
	import uHeadline from "@/decorates/u_headline.vue"; // 公告组件
	import uSearch from "@/decorates/u_search.vue"; // 搜索组件
	import uSlideshow from "@/decorates/u_slideshow.vue"; //图片组件
	import uTitle from "@/decorates/u_title.vue"; //标题组件
	import uRichtext from "@/decorates/u_richtext.vue"; //富文本组件
	import uVideo from "@/decorates/u_video.vue"; //视频组件
	import uShareButton from "@/decorates/u_shareButton.vue"; //分享按钮组件

	import { onLoad, onShow } from '@dcloudio/uni-app'
	import { getCurrentInstance, reactive, ref, computed} from "vue";
	import checkUpdate from '@/uni_modules/uni-upgrade-center-app/utils/check-update'
	const { ctx } = getCurrentInstance(); //获取上下文实例，ctx=vue2的this
	import {fnImgRequestPath} from "@/utils/utils";
	import {selectSysParamPlatStoreSetByPlatIdApi} from "../../api/base/base";
	import {selectDecorateInfoBoByShopId} from "../../api/prod/prod";

	const componentData = reactive({})

	onShow(() => {
		// console.log("onShow 我是home")
	})
	
	onLoad(() => {
		// console.log("onLoad 我是home")
		// 初始化首页装修
		getDecorateInfoList()
	})

	// 初始化首页装修
	function getDecorateInfoList() {
		let param = {};
		param.shopId = ctx.platId || 1;
		param.companyId = ctx.platId || 1;
		param.pageType = 1;
		param.prodType = '001';
		param.membChiefGrade = uni.getStorageSync('memb').gradeId;

		selectDecorateInfoBoByShopId(JSON.stringify(param)).then(res => {
			if (res.retCode == 1) {
				// console.log(res)
				Object.assign(componentData, res.obj)
			} else {
				uni.showToast({
					title: '请求错误',
					icon: 'none',
					duration: 1500
				});
			}
		}).catch(err => {
			uni.showToast({
				title: '请求异常',
				icon: 'none',
				duration: 1500
			});
		})
	}

	function fnSelDecorateSuccess() {

	}

	/**
	 * 组件样式
	 */
	const wrapperStyle = computed(() => {
		/**
		 * 判断是否设置背景组件,返回背景组件样式
		 */
		const decorateModuleInfoBoList = componentData.decorateModuleInfoBoList;
		if(decorateModuleInfoBoList != null && decorateModuleInfoBoList.length > 0){
			let obj = decorateModuleInfoBoList.find(item=>item.moduleNo==='B01')
			if(obj != null && obj != undefined && obj.decorateBgBo != null){
				return `
					width: 100%;
					background-color: ${obj.decorateBgBo.backgroundColor ? obj.decorateBgBo.backgroundColor : '#ffffff'};
					background-image: url(${obj.decorateBgBo.backgroundUrl ? getImageUrl(obj.decorateBgBo.backgroundUrl) : ''});
					background-repeat: repeat;
					background-size: 100% 100%;
					bakcground-position: center;
				`;
			}
		}
		return ``;
	})
	
	/**
	 * 模拟onShow方法
	 */
	function onHandleShow() {
	   console.log("onHandleShow 我是home")
	}

	/**
	 * 页面跳转
	 * @param {Object} path
	 */
	function navigateTo(path){
		uni.navigateTo({
		  url: path,
		});
	}
	
	/**
	 * 获取图片地址
	 * @param {Object} imgUrl
	 */
	function getImageUrl(imgUrl){
		return fnImgRequestPath(imgUrl);
	}
	
	// 将 onHandleShow 暴露给父组件
	defineExpose({ onHandleShow });
</script>

<style lang="scss">
body{overflow-x: hidden;}
</style>